import { ref, computed } from 'vue'

let loadingOverlayComponent = null

export const setLoadingOverlayComponent = (component) => {
  loadingOverlayComponent = component
}

export const useLoadingOverlay = () => {
  const loadingCount = ref(0)
  const isLoading = computed(() => loadingCount.value > 0)

  const show = () => {
    loadingCount.value++
  }

  const hide = () => {
    if (loadingCount.value > 0) {
      loadingCount.value--
    }
  }

  return {
    isLoading,
    show,
    hide
  }
}
